"use client";

import { ApolloProvider } from "@/graphql/provider";
import { SessionProvider } from "next-auth/react";
import { NextIntlClientProvider } from "next-intl";
import { Session } from "next-auth";

function AuthProviders({
  session,
  messages,
  locale,
  timezone,
  children,
}: {
  session: Session;
  messages: Record<string, any>;
  locale: string;
  timezone: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <SessionProvider session={session} basePath="/api/auth">
      <ApolloProvider>
        <NextIntlClientProvider
          messages={messages}
          locale={locale}
          timeZone={timezone}
        >
          {children}
        </NextIntlClientProvider>
      </ApolloProvider>
    </SessionProvider>
  );
}

export default AuthProviders;
